import { http, HttpResponse } from "msw";

export const licenseHandlersStatic = [
  http.get("*/api/agent/deployments/:id/licenses", () =>
    HttpResponse.json({ licenses: [] }, { status: 200 })
  ),
];
